<router-outlet></router-outlet>
<app-timezone-mismatch-banner />
@if (showLoading$ | async) {
<div class="initial-loading">
    <div class="loading-card">
        <div class="logo-container">
            <img ngSrc="/app-logo/kottra_pos.png" alt="KOTTRA POS" height="230" width="555">
        </div>

        <div class="loading-content">
            <div class="progress-bar">
                <div class="progress-fill"></div>
            </div>
            <span class="loading-text">កំពុងដំណើរការ...</span>
        </div>
    </div>
</div>
}
<!-- App Update Banner -->
@if (updateApp.updateReady() || updateApp.downloading()) {
<div class="app-update-banner" id="app-update-banner" [class.is-downloading]="updateApp.downloading()">
    <div class="update-banner-content">
        @if (updateApp.downloading()) {
            <div class="update-spinner"></div>
            <div class="update-banner-text">
                <span class="update-banner-title">កំពុងទាញយក...</span>
                <span class="update-banner-sub">កំណែថ្មីកំពុងត្រូវបានរៀបចំ</span>
            </div>
        } @else {
            <div class="update-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>
            </div>
            <div class="update-banner-text">
                <span class="update-banner-title">មានកំណែថ្មី!</span>
                <span class="update-banner-sub">KOTTRA POS បានធ្វើបច្ចុប្បន្នភាព</span>
            </div>
        }
    </div>
    @if (updateApp.updateReady()) {
    <div class="update-banner-actions">
        <button id="app-update-btn" class="update-btn-apply" (click)="updateApp.applyUpdate()">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>
            ធ្វើបច្ចុប្បន្នភាព
        </button>
    </div>
    }
</div>
}

